/**
* Vue Router
*
* @library
*
* https://router.vuejs.org/en/
*/

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
import globals from './../globals'

import api from './../../api'
import { store } from './../store'

const localApp = new Vue({})
var paths = store.getters.paths

function route (paths) {
  var list = []
  for (var i = 0; i < paths.length; i++) {
    list.push(getPath(paths[i]))
  }
  list.push({ path: '*', redirect: store.getters.initialRoute })
  return list
}

function getPath (path) {
  if (!path.breadcrumbs) {
    path.breadcrumbs = [{ text: path.title, icon: path.icon }]
  }

  var item = {
    name: path.view && path.view !== 'Dinamico' ? path.view : path.title,
    path: path.path,
    alias: path.alias,
    meta: path.meta,
    title: path.title,
    icon: path.icon,
    menu: path.menu,
    children: getChildren(path),
    component: view(path),
    props: path.props
  }

  item.meta.title = path.title
  item.meta.breadcrumbs = path.breadcrumbs

  return item
}

function view (path) {
  if (path.view) {
    return function (resolve) {
      require([`@/${path.dir}${path.view}.vue`], resolve)
    }
  } else {
    return function (resolve) {
      require(['../../util/emptyview.vue'], resolve)
    }
  }
}

function getChildren (path) {
  if (path.items) {
    var list = []
    for (var i = 0; i < path.items.length; i++) {
      var item = path.items[i]

      if (path.items[i].dir && path.items[i].items && path.items[i].items.length > 0) {
        path.items[i].items.forEach(function (p) { return (p.parentDir = path.items[i].dir) })
      }
      if (path.items[i].parentDir) { path.items[i].dir = path.dir + path.items[i].parentDir } else { path.items[i].dir = path.dir }

      path.items[i].path = path.path + path.items[i].path

      item.breadcrumbs = []
      if (path.breadcrumbs) {
        path.breadcrumbs.forEach(p => item.breadcrumbs.push(p))
      } else {
        item.breadcrumbs.push({ text: path.title, icon: path.icon })
      }
      item.breadcrumbs.push({ text: item.title, icon: item.icon })

      list.push(getPath(path.items[i]))
    }
    return list
  }
  return null
}

function userHasPermission (path) {
  const userRoles = []
  const jsonRoles = JSON.parse(localStorage.getItem('user')).roles

  if (!Array.isArray(jsonRoles)) { userRoles.push(api.Enums.TipoPerfilOperador[jsonRoles]) } else {
    jsonRoles.forEach(e => {
      userRoles.push(api.Enums.TipoPerfilOperador[e])
    })
  }

  if (path.meta.allRolesRequired) {
    return path.meta.roles.every(r => userRoles.indexOf(r) >= 0)
  } else {
    return path.meta.roles.some(r => userRoles.indexOf(r) >= 0)
  }
}

Vue.use(Router)

// Create a new router
const aux = localApp.$store.getters.customPaths
const iRotasDinamicas = paths.findIndex(p => p.name === 'RotasDinamicas')
if (iRotasDinamicas >= 0) {
  // incluir em paths.js o item abaixo para posicionar as rotas dinâmicas no menu
  // { name: 'RotasDinamicas' },
  paths.splice(iRotasDinamicas, 1, ...aux)
}

const router = new Router({
  mode: 'history',
  routes: route(paths),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}
router.afterEach((to, from) => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(
      () =>
        splashScreen &&
        splashScreen.parentNode.removeChild(splashScreen),
      300
    )
  }

  // On small screens collapse sidenav
  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')
  const user = localStorage.getItem('user')
  if (!to.meta.anonymousAuth) {
    if (!user) {
      localApp.$api.UI.ShowError('Erro', 'Não autenticado')
      return next({ path: '/' })
    } else {
      const dataExpiracao = new Date(JSON.parse(user).expiresAt)
      const dataAtual = new Date()

      if (dataAtual > dataExpiracao || !userHasPermission(to)) {
        localApp.$api.UI.ShowError(
          'Erro',
          'Sessão expirada ou acesso não autorizado '
        )
        localApp.$store.commit('CLEAR_USER_DATA')
        return next({ path: '/' })
      }
    }
  } else {
    if (user) { return next({ path: '/dashboard' }) }
  }

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

router.userHasPermission = userHasPermission

export default router
